import { render, staticRenderFns } from "./list_comment.vue?vue&type=template&id=89f6bc6a&scoped=true&"
import script from "./list_comment.vue?vue&type=script&lang=js&"
export * from "./list_comment.vue?vue&type=script&lang=js&"
import style0 from "./list_comment.vue?vue&type=style&index=0&id=89f6bc6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f6bc6a",
  null
  
)

export default component.exports